module.exports = __webpack_public_path__ + "static/media/autre-dk.f82d93f5.JPG";